import { Injectable } from '@angular/core';
import { extractDataFromProperty } from '@catcore/utils';
import { RestHttpService } from '@catmodules/core/services/rest-http.service';
import { UserdataFile } from '@catmodules/models/userdata-generation/types';
import { Restangular } from 'ngx-restangular';

@Injectable()
export class UserdataFileService extends RestHttpService<UserdataFile> {

  /**
   * Creates an instance of userdata file service.
   * @param service
   */
  constructor(service: Restangular) {
    super('userdata-files', service);
  }

  /**
   * Downloads file for
   * @param file
   * @returns file
   */
  downloadFileFor(file: UserdataFile): any {
    if (file) {
      const lookupKey = 'action:download';
      return extractDataFromProperty(file, lookupKey);
    }
    return ({href: ''});
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/userdata-generation/services/userdata-file.service.ts